<template>
    <div>
        <div class="mTop">
            <img src="@/assets/m/images/sandwich.svg" class="mTopSwitchIcon" @click="test" />
            <img src="@/assets/tiantaiLogo.png" class="mTopImage" />
        </div>
        <div class="bannerContain">
            <swiper :options="swiperOption">
                <swiper-slide>
                    <img src="@/assets/m/images/banner_guoqingsi.jpg" class="bannerImage" />
                </swiper-slide>
                <swiper-slide>
                    <img src="@/assets/m/images/banner_chichengshan.jpg" class="bannerImage" />
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <van-popup v-model="isShowPopMenu" :style="{ width: '4rem', height: '100%' }" position="left" :closeable="true"
            :overlay="true" get-container="#app">
            <div class="menu">
                <ul>
                    <li @click="to('/m')">首页</li>
                    <li @click="to('/m/about')">关于我们</li>
                </ul>
            </div>
        </van-popup>
    </div>
</template>
<script>

export default {
    data() {
        return {
            isShowPopMenu: false,        //是否显示弹出层
            swiperOption: {
                autoplay: { delay: 3000 },
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            }
        }
    },
    methods: {
        test() {
            this.isShowPopMenu = !this.isShowPopMenu
        },
        to(url) {
            if (this.$route.path != url) {
                this.$router.push(url)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.mTop {
    width: 7.5rem;
    height: .9rem;
    position: fixed;
    left: calc((100% - 7.5rem) / 2);
    top: 0;
    z-index: 12;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .mTopSwitchIcon {
        width: .4rem;
        height: .4rem;
        position: absolute;
        left: .25rem;
        top: .25rem;
        cursor: pointer;
    }

    .mTopImage {
        width: 2.4rem;
        height: .8rem;
    }
}

.bannerContain {
    position: relative;

    .bannerImage {
        width: 7.5rem;
        height: 5.7rem;
        display: block;
    }

    /deep/ .swiper-pagination {
        bottom: .2rem;
    }

    /deep/ .swiper-pagination-bullet {
        width: .3rem;
        height: .03rem;
        background-color: #FFF;
        border-radius: .0.015px;
        margin: 0 .04rem;
    }

    /deep/ .swiper-pagination-bullet-active {
        background-color: #0b82f1;
    }
}

.page {
    padding: .2rem;
}

.menu {
    padding: .2rem;
    background-color: #fff;
    height: 100%;
    box-sizing: border-box;

    ul {
        list-style: none;
        padding: 0;
        margin: .2rem 0;

        li {
            padding: .1rem 0;
            border-bottom: 1px solid #eee;
            cursor: pointer;
        }
    }
}
</style>